import { render, staticRenderFns } from "./register.vue?vue&type=template&id=2abf3df8&scoped=true&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.vue?vue&type=style&index=0&id=2abf3df8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abf3df8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2abf3df8')) {
      api.createRecord('2abf3df8', component.options)
    } else {
      api.reload('2abf3df8', component.options)
    }
    module.hot.accept("./register.vue?vue&type=template&id=2abf3df8&scoped=true&", function () {
      api.rerender('2abf3df8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsBlack/register.vue"
export default component.exports